export default __webpack_public_path__ + "2311d4ced11c44c5efaf9995e0c0f9db.png";